
import React from "react";
import FeedbackRenderer from "./FeedbackRenderer";
import { DiagnosticUtils } from "../../utils/diagnosticUtils";
import { isEnhancedFeedbackAnalysis, validateMarkdownContent } from "../../utils/enhancedFeedbackDetection";

interface FeedbackContentRendererProps {
  content: string;
}

const FeedbackContentRenderer: React.FC<FeedbackContentRendererProps> = ({ content }) => {
  console.log('🎯 FEEDBACK-CONTENT-RENDERER: Processing feedback with enhanced detection');
  console.log('🎯 FEEDBACK-CONTENT-RENDERER: Content length:', content.length);
  console.log('🎯 FEEDBACK-CONTENT-RENDERER: Content preview:', content.substring(0, 500));
  
  // Check if it starts with markdown JSON or raw JSON  
  const isRawJSON = content.trim().startsWith('{') && content.trim().endsWith('}');
  const hasJSONBlock = content.includes('```json');
  console.log('🎯 FEEDBACK-CONTENT-RENDERER: Raw JSON check:', isRawJSON);
  console.log('🎯 FEEDBACK-CONTENT-RENDERER: JSON block check:', hasJSONBlock);
  
  // Use enhanced detection for more reliable feedback identification
  const isFeedback = isEnhancedFeedbackAnalysis(content);
  console.log('🎯 FEEDBACK-CONTENT-RENDERER: Enhanced feedback detection result:', isFeedback);
  
  if (!isFeedback) {
    console.log('❌ FEEDBACK-CONTENT-RENDERER: Content not identified as feedback');
    return null;
  }
  
  // Validate markdown content integrity
  const validation = validateMarkdownContent(content);
  console.log('🎯 FEEDBACK-CONTENT-RENDERER: Content validation:', validation);
  
  if (!validation.isValid) {
    console.log('⚠️ FEEDBACK-CONTENT-RENDERER: Content validation issues:', validation.issues);
  }
  
  // Run original diagnostic for comparison
  DiagnosticUtils.testFeedbackDetection(content);
  
  // Pass directly to dedicated FeedbackRenderer - no intermediate processing
  return <FeedbackRenderer content={content} />;
};

export default FeedbackContentRenderer;
